import useErrorHandler from "../components/ErrorHandler";
import { useDispatch } from "react-redux";
import useMerchantPortalAxios from "../utils/axios";

export const useManageEmployeeStatus = () => {
  const { ErrorHandler } = useErrorHandler();

  // const { GetEmployees } = useEmployeesAPIs();

  const MerchantPortalClient = useMerchantPortalAxios();


  const dispatch = useDispatch();

  const ManageEmployeesStatus = async (payload) => {
      const res = await MerchantPortalClient.post(`/v1/PortalEmployee/ManageBranchEmployeeStatus`, payload);
      return res.data.Payload;
  };

  return {
    ManageEmployeesStatus,
  };
};
